import { useEffect, useState } from 'react';
import axios from "axios";
// import { useUrl } from '@/utils/use-url';

const Loading = () => {
  return (
    <svg className="animate-spin h-20 w-20 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  );
}

interface IQR {
  url?: string;
}

export const QR = (props?: IQR) => {
  // const url = useUrl({ url: props?.url });
  const url = props?.url || location.href;
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getImage = async () => {
      setImage("");
      setLoading(true);
      try {
        const resp = await axios(`/api/id/qr?url=${url}`);
        if (resp.data.image) {
          setImage(resp.data.image);
        }
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }
    if (url) {
      getImage();
    }
  }, [url]);

  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 288, height: 288 }}>
        <Loading />
      </div>
    );
  }

  if (!image) {
    return null;
  }

  return (
      <img className="w-48 h-48 mx-auto my-0" src={image} alt="qr-code" />
  );
}
